import SiteLayout from "../../SiteLayout";
import "../../styles/security.css";

export default function SiteSecurity() {
  return (
    <SiteLayout page="security" title="Security | Shadow" navVariant="flat">
      <header className="hero">
        <div className="wrap">
          <div style={{ fontSize: "14px", fontWeight: 600, color: "var(--blue)" }}>Security</div>
          <h1>Your conversations are<br />the product. We act like it.</h1>
          <p className="lede" style={{ marginLeft: "auto", marginRight: "auto" }}>Shadow handles the most sensitive data a company has: what people actually said. These are the controls it's built on, labeled honestly.</p>
        </div>
      </header>

      <section className="controls">
        <div className="wrap">
          <h2>Controls</h2>
          <p className="lede">What's live, what's next, what's on the roadmap.</p>
          <div className="ctl-grid">
            <div className="ctl">Encryption everywhere<span className="sub">In transit and at rest, always</span><span className="chip now">now</span></div>
            <div className="ctl">Consent controls<span className="sub">Built into the call flow</span><span className="chip now">now</span></div>
            <div className="ctl">Data export and deletion<span className="sub">Full export, then hard deletion</span><span className="chip now">now</span></div>
            <div className="ctl">Tenant isolation<span className="sub">Your graph never crosses boundaries</span><span className="chip now">now</span></div>
            <div className="ctl">Retention policies<span className="sub">Your data, your deletion schedule</span><span className="chip next">next</span></div>
            <div className="ctl">Role-based access control<span className="sub">Who sees what, down to the fact</span><span className="chip next">next</span></div>
            <div className="ctl">SSO and SAML<span className="sub">Okta, Google, Microsoft</span><span className="chip future">roadmap</span></div>
            <div className="ctl">PII redaction<span className="sub">Sensitive data masked at ingestion</span><span className="chip future">roadmap</span></div>
            <div className="ctl">Audit logs<span className="sub">Every access and action, recorded</span><span className="chip future">roadmap</span></div>
            <div className="ctl">SOC 2 Type II<span className="sub">Certification process</span><span className="chip future">in progress</span></div>
            <div className="ctl">Regional deploys<span className="sub">Data residency options</span><span className="chip future">roadmap</span></div>
            <div className="ctl">Admin permissions<span className="sub">Granular workspace controls</span><span className="chip next">next</span></div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
